export default __webpack_public_path__ + "assets/db0dc1fb68e1a5abf4585a29ac6183b9.svg";